module.exports = __webpack_public_path__ + "img/img18.5084332f.png";